import { getSocket, connectSocket } from "./index";
import { eventBus } from "@/eventBus.js";

function initializeListeners(socket) {
  socket.on("audiences:chat:receive", (data) => {
    eventBus.$emit("audiences:chat:receive", data);
  });

  socket.on("entities:queue:updated", (data) => {
    eventBus.$emit("entities:queue-updated", data);
  });

  socket.on("audiences:chat:updated", (data) => {
    eventBus.$emit("audiences:chat:updated", data);
  });

  socket.on("audiences:chat:added", (data) => {
    eventBus.$emit("audiences:chat:added", data);
  });

  socket.on("audiences:chat:removed", (data) => {
    eventBus.$emit("audiences:chat:removed", data);
  });
}

// Chamada para garantir que os listeners sejam inicializados quando o socket estiver conectado
export function ensureAudienceSocketListeners() {
  const socket = getSocket();
  if (socket) {
    initializeListeners(socket);
  } else {
    console.warn("Socket ainda não está conectado. Tentando reconectar...");
    const connectedSocket = connectSocket();
    if (connectedSocket) {
      initializeListeners(connectedSocket);
    }
  }
}

export function joinChatAudience({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("audiences:chat:join", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function addChatAudience({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("audiences:chat:add", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function removeChatAudience({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("audiences:chat:remove", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function leaveChatAudience({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("audiences:chat:leave", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function sendChatAudience({ data }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("audiences:chat:send", data);
  } else {
    console.error("Socket não está conectado.");
  }
}

export function audienceChatMeetEnable({ data, callback }) {
  const socket = getSocket();

  if (socket) {
    return socket.emit("audiences:chat:meet-enable", data, callback);
  } else {
    console.error("Socket não está conectado.");
  }
}

function removeAudienceListeners(socket) {
  socket.off("audiences:chat:receive");
  socket.off("entities:queue:updated");
  socket.off("audiences:chat:updated");
  socket.off("audiences:chat:added");
  socket.off("audiences:chat:removed");
}

export function removeAllAudienceSocketListeners() {
  const socket = getSocket();
  if (socket) {
    removeAudienceListeners(socket);
  } else {
    console.warn("Socket não está conectado.");
  }
}
